
<section
  class="w-full flex flex-row justify-center testimmonial-outer-container bg-themeComponentBg-light font-rubik"
  aria-labelledby="testimonial-heading"
>
  <h2 id="testimonial-heading" class="sr-only">Customer testimonials</h2>

  <div :class="`w-full ${aboutUs ? ' max-w-1216' : ' max-w-1024'}`">
    <div
      :class="`w-full flex-col flex 1240-bp:flex-row bg-testimonialBackground testimmonial-container ${aboutUs ? 'border 1240-bp:rounded-md' : ''}`"
    >
      <div class="w-full 1240-bp:w-5/12 desktop-left-side-container">
        <div class="h-full flex flex-col items-start justify-end gap-1">
          <h3 class="testimonial-h1">Testimonials</h3>
          <p class="text-black testimonial-p">
            Don't take our word for it. Trust our customers.
          </p>
        </div>
      </div>

      <div class="w-7/12 hidden 1240-bp:grid desktop-right-side-container">
        <div
          :class="`grid grid-cols-12 blurred-div ${
            aboutUs ? 'border 1240-bp:rounded-md' : ''
          }`"
          role="list"
          aria-label="Customer testimonials (desktop)"
        >
          <div class="col-span-10 flex flex-row">
            <div
              ref="leftCol"
              class="w-full flex flex-col items-end overflow-scroll card-column-container"
            >
              <div
                v-for="(testimonial, index) in leftCol"
                :key="`left-${index}`"
                role="listitem"
              >
                <testimonial-card :testimonial="testimonial" />
              </div>
            </div>

            <div
              ref="rightCol"
              class="w-full flex flex-col items-start overflow-scroll card-column-container"
            >
              <div class="shadow-right">
                <div
                  v-for="(testimonial, index) in rightCol"
                  :key="`right-${index}`"
                  role="listitem"
                >
                  <testimonial-card :testimonial="testimonial" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        class="w-full 1240-bp:hidden pl-5 pt-5 pb-5 testimonial-mobile-card-main-container"
      >
        <div
          class="testimonial-mobile-card-wrapper"
          role="list"
          aria-label="Customer testimonials (mobile)"
        >
          <div
            class="w-full flex flex-row overflow-x-auto gap-4 testimonial-mobile-card-container"
          >
            <testimonial-card-mobile
              v-for="(testimonial, index) in testimonials"
              :key="`testimonial-${index}`"
              :testimonial="testimonial"
              role="listitem"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
